import z from "zod"

export const ZUlcerItem = z.object({
	UlcerType: z.string(),
	UlcerSite: z.string(),
	UlcerStage: z.string(),
	ICD10_1: z.string(),
	Rank: z.number(),
})
export type UlcerItem = z.infer<typeof ZUlcerItem>
